
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "feedback-public-submission-ui",
  currentProjectVersion: "static-1.31065",
  depVersions: {
  "feedback-public-submission-ui": "static-1.31065",
  "emoji-mart": "static-3.9",
  "feedback-schema": "static-1.55654",
  "head-dlb": "static-1.5330",
  "hs-test-utils": "static-1.8547",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11996",
  "I18n": "static-7.1716",
  "quartz": "static-1.7698",
  "quartz-config": "static-1.1476",
  "quartz-core": "static-1.6917",
  "react-dlb": "static-1.96",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.86",
  "reselect": "static-3.18",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1130",
  "enviro": "static-4.523",
  "feedback-shared-ui": "static-1.55641",
  "feedback-utils": "static-1.55645",
  "forms-embed-utils-lib": "static-1.4968",
  "forms-utils-lib": "static-1.13384",
  "foundations-assets": "static-1.5395",
  "foundations-components": "static-1.8797",
  "foundations-theming": "static-1.4998",
  "hub-http": "static-1.6710",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12303",
  "icons": "static-2.710",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4247",
  "raven": "static-3.6411",
  "react": "static-7.204",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17243",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5682",
  "react-virtualized": "static-2.114",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.520",
  "tinymce-plugins": "static-1.58565",
  "transmute": "static-2.97",
  "ui-images": "static-2.1284",
  "UIComponents": "static-3.8942",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3975",
  "quartz-webpack": "static-1.3922",
  "foundations-theming-specialty": "static-1.2714",
  "property-description-translator": "static-1.4325",
  "HeadJS": "static-2.830",
  "framer-motion": "static-1.86",
  "hs-test-utils-bend-plugin": "static-1.3658",
  "msw": "static-1.105",
  "msw-config": "static-1.36",
  "testing-library": "static-1.167",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4810",
  "jasmine-runner": "static-1.6961",
  "opentelemetry-fe-types": "static-1.300",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.914",
  "hubspotter-http": "static-1.4991",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.675",
  "quartz-auth": "static-1.1373",
  "quartz-head": "static-1.1363",
  "quartz-i18n": "static-1.1373",
  "quartz-routing": "static-1.1128",
  "quartz-test": "static-1.1373",
  "quartz-tracking": "static-1.1077",
  "trellis-components": "static-1.3196",
  "ui-fonts": "static-1.1258",
  "usage-tracker-container": "static-1.7816",
  "usage-tracker-core": "static-1.7676",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.391",
  "conversations-skeleton-state": "static-1.7622",
  "reference-resolvers": "static-1.8692",
  "sanitize-text": "static-1.8666",
  "PatternValidationJS": "static-1.3389",
  "ReduxMessenger": "static-2.10878",
  "outpost": "static-1.4638",
  "rpc-client-utils": "static-1.5170",
  "sanitize": "static-1.4974",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.5066",
  "floating-ui": "static-1.70",
  "hs-story-utils": "static-1.9936",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.112",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3177",
  "bend-plugin-foundations-theming": "static-1.3481",
  "foundations-theming-base": "static-1.3983",
  "stylex": "static-1.48",
  "hs-locale-management": "static-1.419",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.207",
  "web-vitals": "static-1.21",
  "ai-components-ui-library": "static-1.10075",
  "atom": "static-1.5580",
  "codemirror": "static-5.108",
  "content-assistance-lib": "static-1.8466",
  "ContentUtils": "static-1.69546",
  "data-token-picker": "static-1.17183",
  "file-manager-components": "static-1.24888",
  "FileManagerCore": "static-1.40387",
  "FileManagerLib": "static-1.40528",
  "frontend-preferences-client": "static-1.8427",
  "hub-http-contrib": "static-1.3536",
  "interframe": "static-3.5247",
  "layout-dnd-components": "static-1.13272",
  "layout-dnd-utils": "static-1.12247",
  "property-translator": "static-1.5885",
  "react-codemirror": "static-1.11148",
  "react-colorpicker": "static-2.10713",
  "reference-resolvers-lite": "static-1.8619",
  "rich-text-lib": "static-1.20602",
  "tinymce-data": "static-1.41536",
  "tinymce-themes": "static-1.57421",
  "ui-addon-emoji-picker": "static-1.10371",
  "ui-addon-sales-email": "static-1.5711",
  "ui-brand-identity-lib": "static-1.17020",
  "bender-build-tools": "static-1.3622",
  "opentelemetry-web": "static-1.25",
  "hub-http-shared-msw-handlers": "static-1.10955",
  "hubspotter-http-shared-msw-handlers": "static-1.10953",
  "usage-tracker-session-replay": "static-1.5512",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "trellis-theming": "static-1.1528",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.580",
  "chirp-fetch": "static-1.2409",
  "stylex-utils": "static-1.183",
  "chatspot-core": "static-1.24069",
  "copilot-toolkit": "static-1.12209",
  "customer-data-objects-ui-components": "static-1.13540",
  "data-fetching-client": "static-1.10145",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5262",
  "ui-addon-video-player": "static-1.9127",
  "ui-coaching-tips": "static-1.29613",
  "usage-tracker": "static-1.7826",
  "cms-field-types": "static-1.5319",
  "content-icons-ui": "static-1.2489",
  "integrations-lib": "static-1.17495",
  "customer-data-objects": "static-1.8219",
  "apollo-dlb": "static-3.98",
  "apollo-link-hub-http": "static-2.5097",
  "apollo-stack-hubspot": "static-3.101",
  "breeze-engine-lib": "static-1.2278",
  "graphql": "static-1.95",
  "immer": "static-1.107",
  "immerable": "static-1.4647",
  "poll-commands": "static-1.3981",
  "ui-addon-iframeable": "static-1.9585",
  "video-components-external": "static-1.12499",
  "video-data-lib": "static-1.36157",
  "audio-components": "static-1.6612",
  "breeze-artifacts-sdk": "static-1.1088",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30105",
  "FileManagerImages": "static-1.38039",
  "foundations-components-legacy": "static-1.1822",
  "html-to-image": "static-1.67",
  "redux-toolkit": "static-1.84",
  "salesImages": "static-1.764",
  "ui-universal-auth": "static-1.9804",
  "urlinator": "static-1.5022",
  "video-components": "static-1.14501",
  "video-embed": "static-1.36991",
  "ts-schema": "static-1.4411",
  "ContentData": "static-1.69621",
  "layout-data-lib": "static-1.10572",
  "react-dnd-compat": "static-1.5112",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2058",
  "external-options-client-types": "static-1.4455",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6096",
  "hs-resources": "static-1.694",
  "inbound-db-properties-service-client": "static-1.4168",
  "NamespacedHubStyle": "static-2.9384",
  "growth-onboarding-confetti": "static-1.3566",
  "SharedI18nStrings": "static-1.190",
  "ui-addon-i18n": "static-1.11653",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5933",
  "magpie-types": "static-1.5393",
  "simple-logging-lib": "static-1.3555",
  "avatar-components": "static-1.2995",
  "customer-data-ui-utilities": "static-1.10340",
  "growth-onboarding-feedback-components": "static-1.7089",
  "flux-actions": "static-1.383",
  "hubspot-apollo-client": "static-1.5387",
  "integrations-error-boundary-lib": "static-1.14910",
  "integrations-tracking-lib": "static-1.6132",
  "laboratory-lib": "static-3.7655",
  "native-integrations-shared-strings": "static-1.8266",
  "redux-observable": "static-1.81",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10790",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1256",
  "breeze-engine-core": "static-1.1556",
  "highlight.js": "static-1.92",
  "pulse": "static-1.1160",
  "navigation-messaging": "static-1.8555",
  "content-media-composition-data-lib": "static-1.13646",
  "content-media-compositions": "static-2.17653",
  "idb-keyval": "static-1.57",
  "media-bridge-lib": "static-1.19687",
  "nudge-client-utils": "static-1.3466",
  "custom-vendor-connection-lib": "static-1.368",
  "unified-auth-core-lib": "static-1.1600",
  "social-insights-client-types": "static-1.22981",
  "advanced-menus-core": "static-1.15865",
  "advanced-menus-lib": "static-1.12607",
  "ExportDialog": "static-6.10880",
  "ui-memberships-settings-lib": "static-1.35263",
  "conditional-properties-service-client": "static-1.4130",
  "crm-pipelines-api-client-types": "static-1.4460",
  "event-emitter": "static-1.1465",
  "fdsr-migration-layer": "static-1.521",
  "framework-builder-read-service-client": "static-1.4352",
  "inbound-db-meta-service-client": "static-1.3791",
  "multi-currency-client-types": "static-1.4025",
  "foundations-components-test-utils": "static-1.6280",
  "reactive-lib": "static-1.1228",
  "trellis-migration-context": "static-1.86",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.846",
  "universal-page-editor-lib": "static-1.3522",
  "bend-plugin-pulse": "static-1.663",
  "fast-json-patch": "static-1.76",
  "nav-meta": "static-1.30865",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3223",
  "nudge-renderer-utils": "static-1.3542",
  "onboarding-tours": "static-1.17435",
  "whisper-core-api": "static-1.7682",
  "fsm": "static-1.4266",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15864",
  "simple-menus-lib": "static-1.17381",
  "settings-ui-lib": "static-1.13036",
  "persist-promise": "static-1.4215",
  "crm-record-cards-client": "static-1.134",
  "crm-record-cards-service-types": "static-1.3878",
  "framework-data-schema-resolvers": "static-1.7402",
  "location-customization-utils-lib": "static-1.10482",
  "getting-started-shared-tasks": "static-1.19618",
  "growth-data-modal": "static-1.6174",
  "growth-onboarding-next-action-utils": "static-1.3039",
  "navigation-components": "static-1.19228",
  "nest": "static-1.742",
  "onboarding-tours-client": "static-1.5650",
  "onboarding-tours-utils": "static-1.1502",
  "ui-shepherd-tracker": "static-1.8171",
  "user-context": "static-1.5563",
  "react-flip-move": "static-1.85",
  "framework-data-schema-quick-fetch": "static-1.7307",
  "onboarding-data-sync-lib": "static-1.2881",
  "growth-onboarding-next-action-components": "static-1.3067",
  "user-context-client": "static-1.5017",
  "getting-started-shared-tasks-store": "static-1.18736",
  "InboxConnectUtils": "static-4.15895",
  "meetings-connect-utils-lib": "static-1.8124",
  "onboarding-scopes": "static-1.6957"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.31065",
  "emoji-mart": "/emoji-mart/static-3.9",
  "feedback-schema": "/feedback-schema/static-1.55654",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-test-utils": "/hs-test-utils/static-1.8547",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11996",
  "I18n": "/I18n/static-7.1716",
  "quartz": "/quartz/static-1.7698",
  "quartz-config": "/quartz-config/static-1.1476",
  "quartz-core": "/quartz-core/static-1.6917",
  "react-dlb": "/react-dlb/static-1.96",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.86",
  "reselect": "/reselect/static-3.18",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1130",
  "enviro": "/enviro/static-4.523",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55641",
  "feedback-utils": "/feedback-utils/static-1.55645",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4968",
  "forms-utils-lib": "/forms-utils-lib/static-1.13384",
  "foundations-assets": "/foundations-assets/static-1.5395",
  "foundations-components": "/foundations-components/static-1.8797",
  "foundations-theming": "/foundations-theming/static-1.4998",
  "hub-http": "/hub-http/static-1.6710",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12303",
  "icons": "/icons/static-2.710",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4247",
  "raven": "/raven/static-3.6411",
  "react": "/react/static-7.204",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17243",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5682",
  "react-virtualized": "/react-virtualized/static-2.114",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "tinymce-plugins": "/tinymce-plugins/static-1.58565",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1284",
  "UIComponents": "/UIComponents/static-3.8942",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3975",
  "quartz-webpack": "/quartz-webpack/static-1.3922",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2714",
  "property-description-translator": "/property-description-translator/static-1.4325",
  "HeadJS": "/HeadJS/static-2.830",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3658",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.36",
  "testing-library": "/testing-library/static-1.167",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4810",
  "jasmine-runner": "/jasmine-runner/static-1.6961",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.300",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.914",
  "hubspotter-http": "/hubspotter-http/static-1.4991",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.675",
  "quartz-auth": "/quartz-auth/static-1.1373",
  "quartz-head": "/quartz-head/static-1.1363",
  "quartz-i18n": "/quartz-i18n/static-1.1373",
  "quartz-routing": "/quartz-routing/static-1.1128",
  "quartz-test": "/quartz-test/static-1.1373",
  "quartz-tracking": "/quartz-tracking/static-1.1077",
  "trellis-components": "/trellis-components/static-1.3196",
  "ui-fonts": "/ui-fonts/static-1.1258",
  "usage-tracker-container": "/usage-tracker-container/static-1.7816",
  "usage-tracker-core": "/usage-tracker-core/static-1.7676",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.391",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7622",
  "reference-resolvers": "/reference-resolvers/static-1.8692",
  "sanitize-text": "/sanitize-text/static-1.8666",
  "PatternValidationJS": "/PatternValidationJS/static-1.3389",
  "ReduxMessenger": "/ReduxMessenger/static-2.10878",
  "outpost": "/outpost/static-1.4638",
  "rpc-client-utils": "/rpc-client-utils/static-1.5170",
  "sanitize": "/sanitize/static-1.4974",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5066",
  "floating-ui": "/floating-ui/static-1.70",
  "hs-story-utils": "/hs-story-utils/static-1.9936",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.112",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3177",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3481",
  "foundations-theming-base": "/foundations-theming-base/static-1.3983",
  "stylex": "/stylex/static-1.48",
  "hs-locale-management": "/hs-locale-management/static-1.419",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.207",
  "web-vitals": "/web-vitals/static-1.21",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10075",
  "atom": "/atom/static-1.5580",
  "codemirror": "/codemirror/static-5.108",
  "content-assistance-lib": "/content-assistance-lib/static-1.8466",
  "ContentUtils": "/ContentUtils/static-1.69546",
  "data-token-picker": "/data-token-picker/static-1.17183",
  "file-manager-components": "/file-manager-components/static-1.24888",
  "FileManagerCore": "/FileManagerCore/static-1.40387",
  "FileManagerLib": "/FileManagerLib/static-1.40528",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8427",
  "hub-http-contrib": "/hub-http-contrib/static-1.3536",
  "interframe": "/interframe/static-3.5247",
  "layout-dnd-components": "/layout-dnd-components/static-1.13272",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12247",
  "property-translator": "/property-translator/static-1.5885",
  "react-codemirror": "/react-codemirror/static-1.11148",
  "react-colorpicker": "/react-colorpicker/static-2.10713",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8619",
  "rich-text-lib": "/rich-text-lib/static-1.20602",
  "tinymce-data": "/tinymce-data/static-1.41536",
  "tinymce-themes": "/tinymce-themes/static-1.57421",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10371",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5711",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17020",
  "bender-build-tools": "/bender-build-tools/static-1.3622",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10955",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10953",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5512",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "trellis-theming": "/trellis-theming/static-1.1528",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.580",
  "chirp-fetch": "/chirp-fetch/static-1.2409",
  "stylex-utils": "/stylex-utils/static-1.183",
  "chatspot-core": "/chatspot-core/static-1.24069",
  "copilot-toolkit": "/copilot-toolkit/static-1.12209",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13540",
  "data-fetching-client": "/data-fetching-client/static-1.10145",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5262",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9127",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29613",
  "usage-tracker": "/usage-tracker/static-1.7826",
  "cms-field-types": "/cms-field-types/static-1.5319",
  "content-icons-ui": "/content-icons-ui/static-1.2489",
  "integrations-lib": "/integrations-lib/static-1.17495",
  "customer-data-objects": "/customer-data-objects/static-1.8219",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5097",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.101",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2278",
  "graphql": "/graphql/static-1.95",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4647",
  "poll-commands": "/poll-commands/static-1.3981",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9585",
  "video-components-external": "/video-components-external/static-1.12499",
  "video-data-lib": "/video-data-lib/static-1.36157",
  "audio-components": "/audio-components/static-1.6612",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1088",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30105",
  "FileManagerImages": "/FileManagerImages/static-1.38039",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1822",
  "html-to-image": "/html-to-image/static-1.67",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "salesImages": "/salesImages/static-1.764",
  "ui-universal-auth": "/ui-universal-auth/static-1.9804",
  "urlinator": "/urlinator/static-1.5022",
  "video-components": "/video-components/static-1.14501",
  "video-embed": "/video-embed/static-1.36991",
  "ts-schema": "/ts-schema/static-1.4411",
  "ContentData": "/ContentData/static-1.69621",
  "layout-data-lib": "/layout-data-lib/static-1.10572",
  "react-dnd-compat": "/react-dnd-compat/static-1.5112",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2058",
  "external-options-client-types": "/external-options-client-types/static-1.4455",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6096",
  "hs-resources": "/hs-resources/static-1.694",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4168",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9384",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3566",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11653",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5933",
  "magpie-types": "/magpie-types/static-1.5393",
  "simple-logging-lib": "/simple-logging-lib/static-1.3555",
  "avatar-components": "/avatar-components/static-1.2995",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10340",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7089",
  "flux-actions": "/flux-actions/static-1.383",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5387",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14910",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6132",
  "laboratory-lib": "/laboratory-lib/static-3.7655",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8266",
  "redux-observable": "/redux-observable/static-1.81",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10790",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1256",
  "breeze-engine-core": "/breeze-engine-core/static-1.1556",
  "highlight.js": "/highlight.js/static-1.92",
  "pulse": "/pulse/static-1.1160",
  "navigation-messaging": "/navigation-messaging/static-1.8555",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13646",
  "content-media-compositions": "/content-media-compositions/static-2.17653",
  "idb-keyval": "/idb-keyval/static-1.57",
  "media-bridge-lib": "/media-bridge-lib/static-1.19687",
  "nudge-client-utils": "/nudge-client-utils/static-1.3466",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.368",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1600",
  "social-insights-client-types": "/social-insights-client-types/static-1.22981",
  "advanced-menus-core": "/advanced-menus-core/static-1.15865",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12607",
  "ExportDialog": "/ExportDialog/static-6.10880",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35263",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4130",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4460",
  "event-emitter": "/event-emitter/static-1.1465",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.521",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4352",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3791",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4025",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6280",
  "reactive-lib": "/reactive-lib/static-1.1228",
  "trellis-migration-context": "/trellis-migration-context/static-1.86",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.846",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3522",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.663",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "nav-meta": "/nav-meta/static-1.30865",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3223",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3542",
  "onboarding-tours": "/onboarding-tours/static-1.17435",
  "whisper-core-api": "/whisper-core-api/static-1.7682",
  "fsm": "/fsm/static-1.4266",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15864",
  "simple-menus-lib": "/simple-menus-lib/static-1.17381",
  "settings-ui-lib": "/settings-ui-lib/static-1.13036",
  "persist-promise": "/persist-promise/static-1.4215",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.134",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3878",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7402",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10482",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19618",
  "growth-data-modal": "/growth-data-modal/static-1.6174",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3039",
  "navigation-components": "/navigation-components/static-1.19228",
  "nest": "/nest/static-1.742",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5650",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1502",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8171",
  "user-context": "/user-context/static-1.5563",
  "react-flip-move": "/react-flip-move/static-1.85",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7307",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2881",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3067",
  "user-context-client": "/user-context-client/static-1.5017",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18736",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15895",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8124",
  "onboarding-scopes": "/onboarding-scopes/static-1.6957"
}
};
